module.exports = __webpack_public_path__ + "static/media/Margaery Tyrell 2.08848599.jpg";